
	import { defineComponent } from 'vue'
	import Dialog from 'primevue/dialog'

	export default defineComponent({
		name: 'export-dialog',
		components: { Dialog },
		props: {
			visibility: Boolean
		},
		data() {
			return { fileName: '' }
		},
		created() {},
		emits: ['update:visibility', 'export'],
		methods: {
			closeDialog(): void {
				this.$emit('update:visibility', false)
			},
			emitExport(): void {
				this.$emit('export', this.fileName)
			}
		}
	})
